"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipType = void 0;
/** Options that define how the markers are cluster (more information here: https://react-google-maps-api-docs.netlify.app/#markerclusterer) */
let TooltipType = exports.TooltipType = /*#__PURE__*/function (TooltipType) {
  TooltipType["CUSTOM"] = "custom";
  TooltipType["DEFAULT"] = "default";
  return TooltipType;
}({});